import { useMemo } from 'react';

import { DictTypes } from '@/constants';
import { setDictionaryOptions } from '@/services';
import { useAppSelector } from '@/store';

interface IProps {
  chosenDealer: string;
}

const useSelectsOptions = ({ chosenDealer }: IProps) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const hasUsedCarsDealer = useMemo(() => {
    const dealer = dicts?.[DictTypes.Dealers]?.getBy.code[chosenDealer];
    const brands = dicts?.[DictTypes.Brands]?.content?.filter((item) =>
      dealer?._brandUuids.includes(item.uuid)
    );

    // 8 - Код бренда Li
    return brands?.some((item) => item.code === 8) || dealer?.is_sold_used_cars;
  }, [dicts, chosenDealer]);

  const dealers = useMemo(
    () =>
      setDictionaryOptions(DictTypes.Dealers, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const autoTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.AutoTypes, dicts)
        ?.map((item) => ({
          value: String(item.value),
          label: String(item.label)
        }))
        // Фильтруем по Б\У авто, если есть дилер с определенным брендом
        .filter((item) => item.value !== '2' || hasUsedCarsDealer) || [],
    [dicts, hasUsedCarsDealer]
  );
  const loanTerms = useMemo(
    () =>
      setDictionaryOptions(DictTypes.LoanTerms, dicts)
        ?.map((item) => ({
          value: String(item.value),
          label: String(item.label)
        }))
        .sort((a, b) => +b.value - +a.value) || [],
    [dicts]
  );
  const engineTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.EngineTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const repaymentTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.RepaymentTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );

  return { dealers, autoTypes, loanTerms, engineTypes, repaymentTypes };
};

export default useSelectsOptions;
